import * as core from '../../../../../../../core'

import { query } from './risk-assessment-survey.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.risk-assessment',
    description: 'Subaward Risk Assessment',
    name: 'Subaward Risk Assessment',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
